import { render, staticRenderFns } from "./UpdateProperty.vue?vue&type=template&id=59136773&scoped=true"
import script from "./UpdateProperty.vue?vue&type=script&lang=js"
export * from "./UpdateProperty.vue?vue&type=script&lang=js"
import style0 from "./UpdateProperty.vue?vue&type=style&index=0&id=59136773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59136773",
  null
  
)

export default component.exports